import type { ReportListItem } from "../types/types.ts"

export interface ReportFolderGroup {
  folder: string
  reports: ReportListItem[]
}

const folderKey = (report: ReportListItem): string =>
  report.folder?.trim() ? report.folder : ""

const byName = (a: ReportListItem, b: ReportListItem): number =>
  a.name.localeCompare(b.name)

export const groupReportsByFolder = (
  reports: ReportListItem[]
): ReportFolderGroup[] => {
  const buckets = new Map<string, ReportListItem[]>()
  for (const report of reports) {
    const key = folderKey(report)
    const bucket = buckets.get(key)
    if (bucket) bucket.push(report)
    else buckets.set(key, [report])
  }

  const groups: ReportFolderGroup[] = []
  const ungrouped = buckets.get("")
  if (ungrouped?.length)
    groups.push({ folder: "", reports: [...ungrouped].sort(byName) })

  const folders = [...buckets.keys()]
    .filter((folder) => folder !== "")
    .sort((a, b) => a.localeCompare(b))
  for (const folder of folders)
    groups.push({ folder, reports: [...buckets.get(folder)!].sort(byName) })

  return groups
}

export const distinctFolderNames = (reports: ReportListItem[]): string[] =>
  [
    ...new Set(
      reports
        .map((report) => report.folder)
        .filter((folder): folder is string => !!folder && folder.trim() !== "")
    )
  ].sort((a, b) => a.localeCompare(b))
